import { PublicVoucherData } from '@/domain/entities/PublicVoucher'
import {
  CreatePublicVoucherRequestInterface,
  UpdatePublicVoucherRequestInterface,
  DeletePublicVoucherRequestInterface,
} from '@/data/payload/contracts/PublicVoucherRequest'

export class CreatePublicVoucherRequest
  implements CreatePublicVoucherRequestInterface {
  public voucherName?: string
  public voucherCode?: string
  public limitPerDay?: number
  public voucherPurpose?: string
  public limitUsagePerUser?: number
  public voucherData?: PublicVoucherData
  public startDate?: string
  public endDate?: string
  public actorName?: string

  constructor(
    voucherName?: string,
    voucherCode?: string,
    limitPerDay?: number,
    voucherPurpose?: string,
    limitUsagePerUser?: number,
    voucherData?: PublicVoucherData,
    startDate?: string,
    endDate?: string,
    actorName?: string
  ) {
    this.voucherName = voucherName
    this.voucherCode = voucherCode
    this.limitPerDay = limitPerDay
    this.voucherPurpose = voucherPurpose
    this.limitUsagePerUser = limitUsagePerUser
    this.voucherData = voucherData
    this.startDate = startDate
    this.endDate = endDate
    this.actorName = actorName
  }

  public toPayload() {
    const data = {
      public_voucher_name: this.voucherName,
      public_voucher_code: this.voucherCode,
      limit_per_day: this.limitPerDay,
      public_voucher_purpose: this.voucherPurpose,
      limit_usage_per_user: this.limitUsagePerUser,
      voucher_expiry_day: this.voucherData?.expiryDay,
      public_voucher_data: {
        point_amount: this.voucherData?.pointAmount,
        point_purpose: this.voucherData?.pointPurpose,
        point_expiry_day: this.voucherData?.pointExpiryDay,
      },
      start_date: this.startDate,
      end_date: this.endDate,
      actor_name: this.actorName,
    }

    return JSON.stringify({
      ...data,
    })
  }
}

export class UpdatePublicVoucherRequest
  implements UpdatePublicVoucherRequestInterface {
  public limitPerDay?: number
  public voucherPurpose?: string
  public limitUsagePerUser?: number
  public voucherData?: PublicVoucherData
  public startDate?: string
  public endDate?: string
  public actorName?: string

  constructor(
    limitPerDay?: number,
    voucherPurpose?: string,
    limitUsagePerUser?: number,
    voucherData?: PublicVoucherData,
    startDate?: string,
    endDate?: string,
    actorName?: string
  ) {
    this.limitPerDay = limitPerDay
    this.voucherPurpose = voucherPurpose
    this.limitUsagePerUser = limitUsagePerUser
    this.voucherData = voucherData
    this.startDate = startDate
    this.endDate = endDate
    this.actorName = actorName
  }

  public toPayload() {
    const data = {
      limit_per_day: this.limitPerDay,
      public_voucher_purpose: this.voucherPurpose,
      limit_usage_per_user: this.limitUsagePerUser,
      voucher_expiry_day: this.voucherData?.expiryDay,
      public_voucher_data: {
        point_amount: this.voucherData?.pointAmount,
        point_purpose: this.voucherData?.pointPurpose,
        point_expiry_day: this.voucherData?.pointExpiryDay,
      },
      start_date: this.startDate,
      end_date: this.endDate,
      actor_name: this.actorName,
    }

    return JSON.stringify({
      ...data,
    })
  }
}

export class DeletePublicVoucherRequest
  implements DeletePublicVoucherRequestInterface {
  public actorName?: string

  constructor(actorName?: string) {
    this.actorName = actorName
  }

  public toPayload() {
    const data = {
      actor_name: this.actorName,
    }

    return JSON.stringify({
      ...data,
    })
  }
}
